// extracted by mini-css-extract-plugin
export default {"targetHeader":"TargetHeader_targetHeader__4JSt1"};